<template>
  <div class="deluxe-result-manager-base" v-if="!!deluxeInfo">
    <component
      :is="targetComponent"
      :item-name="itemName"
      :item-price="itemPrice"
      :subsc-price="subscPrice"
      :subsc-url="subscUrl"
      :is-subsc-active="isSubscActive"
      :free-flg="freeFlg"
      :deluxe-info="deluxeInfo"
      :buy-link="buyLink"
    />
  </div>
</template>

<script>
import DeluxeResultA from './components/DeluxeResultA'
export default {
  name: 'DeluxeResultManager',
  props: {
    itemName: {
      type: String,
      default: null,
    },
    subscUrl:{
      type: String,
      default: '/'
    },
    freeFlg: {
      type: Boolean,
      default: false,
    },
    itemPrice: {
      type: Number,
      default: null,
    },
    subscPrice: {
      type: Number,
      default: null,
    },
    isSubscActive: {
      type: Boolean,
      default: false,
    },
    deluxeInfo: {
      type: Object,
      default(){
        return null
      }
    },
    buyLink: {
      type: String,
      default: '/'
    },
  },
  computed: {
    targetComponent(){
      return DeluxeResultA
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.deluxe-result-manager-base {
  width: 100%;
  height: 100%;
  background: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/utvStore/components/deluxe/DeluxeResultManager.vue